import React, { useState } from 'react';
function AnimalZakatTable({ result }) {
  let camelColSpan;
  if(result.camel.zakatDuty === 'no')
  {
    camelColSpan = 2
  } else if (result.camel.operator)
  {
    camelColSpan = 5
  } else
  {
    camelColSpan = 3
  }
  let cowColSpan;
  if(result.cow.zakatDuty === 'no')
  {
    cowColSpan = 2
  } else if (result.cow.operator)
  {
    cowColSpan = 5
  } else
  {
    cowColSpan = 3
  }
  let sheepColSpan;
  if(result.sheep.zakatDuty === 'no')
  {
    sheepColSpan = 2
  } else if (result.sheep.operator)
  {
    sheepColSpan = 5
  } else
  {
    sheepColSpan = 3
  }
  return (
    <table >
      <thead>
        <tr>
          <th >Type d'animal</th>
          <th colSpan={3} className="bmi-header"> Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td rowSpan={camelColSpan} >Chameaux</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Obligation de Zakat	</b></td>
          <td >{result.camel.zakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        {result.camel.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Montant de la Zakat</b> </td>
            <td colSpan={2}>{result.camel.zakatAmount_1} - {result.camel.description_ar_1}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.camel.operator === 'or' ? 'ou' : 'et'}</td>
          </tr>
        )}
        {result.camel.operator && result.camel.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.camel.zakatAmount_2} - {result.camel.description_ar_2}</td>
          </tr>
        )}
        <tr >
          <td colSpan={4} className="bmi-header">
          </td>
        </tr>
        <tr>
          <td rowSpan={cowColSpan} >Bovins</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Obligation de Zakat	</b></td>
          <td >{result.cow.zakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        {result.cow.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Montant de la Zakat</b> </td>
            <td colSpan={2}>{result.cow.zakatAmount_1} - {result.cow.description_ar_1}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.cow.operator === 'or' ? 'ou' : 'et'}</td>
          </tr>
        )}
        {result.cow.operator && result.cow.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.cow.zakatAmount_2} - {result.cow.description_ar_2}</td>
          </tr>
        )}
        <tr >
          <td colSpan={4} className="bmi-header">
          </td>
        </tr>
        <tr>
          <td rowSpan={sheepColSpan} >Ovins</td>
        </tr>
        <tr >
          <td colSpan={2} ><b> Obligation de Zakat	</b></td>
          <td >{result.sheep.zakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        {result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td rowSpan={3}><b>Montant de la Zakat</b> </td>
            <td colSpan={2}>{result.sheep.zakatAmount_1} - {result.sheep.description_ar_1}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}> {result.sheep.operator === 'or' ? 'ou' : 'et'}</td>
          </tr>
        )}
        {result.sheep.operator && result.sheep.zakatDuty === 'yes' && (
          <tr>
            <td colSpan={2}>{result.sheep.zakatAmount_2} - {result.sheep.description_ar_2}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}
export default AnimalZakatTable;
